import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SearchPage.css';

const SearchPage = () => {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (trackingNumber.trim()) {
      const encodedTracking = btoa(trackingNumber.trim());
      navigate(`/status/${encodedTracking}`);
    }
  };

  return (
    <div className="search-page">
      <div className="search-container">
        <div className="logo">
          <img src={require('../assets/images/2go-logo.png')} alt="2GO" style={{ height: '100px', marginBottom: '0px' }} />
          <h1>Express Tracking</h1>
        </div>
        
        <form onSubmit={handleSubmit} className="search-form">
          <div className="search-box">
            <div className="search-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M21.71 20.29L18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42-1.42zM11 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7z"/>
              </svg>
            </div>
            <input
              type="text"
              className="input search-input"
              placeholder={!isFocused ? "Enter tracking number" : ""}
              value={trackingNumber}
              onChange={(e) => setTrackingNumber(e.target.value)}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              autoFocus
            />
            <button type="submit" className="btn btn-primary search-btn">
              Track
            </button>
          </div>
        </form>
        

      </div>
    </div>
  );
};

export default SearchPage;